(() => {
  const doc = document;
  const drawer = doc.querySelector('[data-cart-drawer]');
  if (!drawer) return;

  const config = window.SIMOTEK_DELIVERY_CONFIG || {};
  const root = window.Shopify?.routes?.root || '/';
  const feeHandle = config.feeProductHandle || 'frais-de-livraison-simotek';
  const rates = window.SIMOTEK_DELIVERY_RATES || [];
  const normalize = window.SimotekUtils?.normalizeCity || ((value='') => String(value).trim().toLowerCase());
  const escapeHTML = window.SimotekUtils?.escapeHTML || ((value='') => String(value).replace(/[&<>'"]/g, c => ({'&':'&amp;','<':'&lt;','>':'&gt;',"'":'&#39;','"':'&quot;'}[c])));
  const track = (name, payload = {}) => window.SimotekAnalytics?.track?.(name, payload);

  const panel = drawer.querySelector('.simotek-cart-drawer__panel');
  const body = drawer.querySelector('[data-cart-drawer-body]');
  const footer = drawer.querySelector('[data-cart-drawer-footer]');
  const countNode = drawer.querySelector('[data-cart-drawer-count]');
  const cityInput = drawer.querySelector('[data-cart-drawer-city]');
  const suggestions = drawer.querySelector('[data-cart-drawer-suggestions]');
  const applyButton = drawer.querySelector('[data-cart-drawer-apply]');
  const shippingStatus = drawer.querySelector('[data-cart-drawer-shipping-status]');
  const checkoutButton = drawer.querySelector('[data-cart-drawer-checkout]');
  const productsTotalNode = drawer.querySelector('[data-cart-drawer-products-total]');
  const shippingTotalNode = drawer.querySelector('[data-cart-drawer-shipping-total]');
  const totalNode = drawer.querySelector('[data-cart-drawer-total]');

  const indexedRates = rates.map(rate => ({...rate, _key: normalize(rate.city)}));
  const exactRates = new Map(indexedRates.map(rate => [rate._key, rate]));
  let selectedRate = null;
  let feeProductPromise = null;
  let currentCart = null;
  let busy = false;

  const money = cents => `${(Number(cents || 0) / 100).toLocaleString('fr-MA', {maximumFractionDigits: 0})} DH`;
  const moneyDh = amount => `${Number(amount || 0).toLocaleString('fr-MA', {maximumFractionDigits: 0})} DH`;
  const localePath = path => `${root}${path}`.replace(/\/+/g, '/');
  const isFeeItem = item => item.handle === feeHandle || item.properties?._simotek_delivery_fee === '1';

  const findRate = query => {
    const key = normalize(query);
    if (!key) return null;
    if (exactRates.has(key)) return exactRates.get(key);
    const starts = indexedRates.filter(rate => rate._key.startsWith(key));
    if (starts.length === 1) return starts[0];
    const contains = indexedRates.filter(rate => rate._key.includes(key));
    return contains.length === 1 ? contains[0] : null;
  };

  const getSuggestions = (query, limit = 8) => {
    const key = normalize(query);
    const list = key ? indexedRates.filter(rate => rate._key.includes(key)) : indexedRates.slice(0, limit);
    return list.sort((a,b) => {
      const as = key && a._key.startsWith(key) ? 0 : 1;
      const bs = key && b._key.startsWith(key) ? 0 : 1;
      return as - bs || a.city.localeCompare(b.city, 'fr');
    }).slice(0, limit);
  };

  const fetchCart = async () => {
    const response = await fetch(localePath('cart.js'), {credentials: 'same-origin', headers: {Accept: 'application/json'}});
    if (!response.ok) throw new Error(`CART_${response.status}`);
    return response.json();
  };

  const updateGlobalCount = cart => {
    const normalQty = (cart.items || []).filter(item => !isFeeItem(item)).reduce((sum,item) => sum + Number(item.quantity || 0), 0);
    let bubble = doc.querySelector('.cart-count');
    const button = doc.querySelector('.cart-link');
    if (!bubble && button && normalQty > 0) {
      bubble = doc.createElement('span');
      bubble.className = 'cart-count';
      bubble.setAttribute('aria-hidden', 'true');
      button.appendChild(bubble);
    }
    if (bubble) {
      bubble.textContent = String(normalQty);
      bubble.hidden = normalQty < 1;
    }
    if (countNode) countNode.textContent = normalQty ? `(${normalQty})` : '';
  };

  const render = cart => {
    currentCart = cart;
    updateGlobalCount(cart);
    const normalItems = (cart.items || []).filter(item => !isFeeItem(item));
    const feeItem = (cart.items || []).find(isFeeItem) || null;
    const productsTotal = normalItems.reduce((sum,item) => sum + Number(item.final_line_price || item.line_price || 0), 0);
    const feeTotal = feeItem ? Number(feeItem.final_line_price || feeItem.line_price || 0) : 0;

    if (!normalItems.length) {
      body.innerHTML = `<div class="simotek-cart-drawer__empty"><strong>Votre panier est vide</strong><p>Ajoutez un produit pour commencer votre commande.</p><button type="button" class="btn" data-cart-drawer-close>Continuer mes achats</button></div>`;
      footer.hidden = true;
      return;
    }

    body.innerHTML = `<div class="simotek-cart-drawer__items">${normalItems.map(item => `
      <article class="simotek-cart-drawer__item" data-cart-drawer-item data-key="${escapeHTML(item.key)}">
        <img src="${escapeHTML(item.image || '')}" alt="${escapeHTML(item.product_title || item.title || '')}" loading="lazy">
        <div class="simotek-cart-drawer__item-info">
          <strong>${escapeHTML(item.product_title || item.title || '')}</strong>
          ${item.variant_title && item.variant_title !== 'Default Title' ? `<small>${escapeHTML(item.variant_title)}</small>` : ''}
          <span>${money(item.final_price || item.price)}</span>
          <div class="simotek-cart-drawer__qty">
            <button type="button" data-cart-drawer-qty="-1" aria-label="Diminuer">−</button>
            <b>${Number(item.quantity || 0)}</b>
            <button type="button" data-cart-drawer-qty="1" aria-label="Augmenter">+</button>
            <button type="button" class="simotek-cart-drawer__remove" data-cart-drawer-remove>Supprimer</button>
          </div>
        </div>
        <strong class="simotek-cart-drawer__line-total">${money(item.final_line_price || item.line_price)}</strong>
      </article>`).join('')}</div>`;

    footer.hidden = false;
    if (productsTotalNode) productsTotalNode.textContent = money(productsTotal);
    if (shippingTotalNode) shippingTotalNode.textContent = feeItem ? money(feeTotal) : '—';
    if (totalNode) totalNode.textContent = money(productsTotal + feeTotal);

    const city = cart.attributes?.['Ville de livraison'] || feeItem?.properties?.['Ville de livraison'] || '';
    selectedRate = city ? findRate(city) : null;
    if (cityInput) cityInput.value = city;
    if (config.enabled === false) {
      checkoutButton.disabled = false;
      checkoutButton.setAttribute('aria-disabled', 'false');
      shippingStatus.textContent = '';
    } else if (feeItem && selectedRate) {
      checkoutButton.disabled = false;
      checkoutButton.setAttribute('aria-disabled', 'false');
      shippingStatus.textContent = `${selectedRate.city} · ${moneyDh(selectedRate.price)} · ${selectedRate.time || 'Délai à confirmer'}`;
      shippingStatus.dataset.type = 'success';
    } else {
      checkoutButton.disabled = true;
      checkoutButton.setAttribute('aria-disabled', 'true');
      shippingStatus.textContent = 'Choisissez votre ville pour calculer les frais de livraison.';
      shippingStatus.dataset.type = '';
    }
  };

  const refresh = async () => {
    body.innerHTML = '<div class="simotek-cart-drawer__loading">Mise à jour du panier…</div>';
    try {
      render(await fetchCart());
    } catch (error) {
      console.error('[SIMOTEK cart drawer]', error);
      body.innerHTML = '<div class="simotek-cart-drawer__error">Impossible de charger le panier. Réessayez.</div>';
      footer.hidden = true;
    }
  };

  const open = async () => {
    drawer.hidden = false;
    doc.body.classList.add('simotek-cart-drawer-open');
    panel?.focus?.();
    await refresh();
    const normalItems = (currentCart?.items || []).filter(item => !isFeeItem(item));
    track('cart_drawer_open', {
      item_count: normalItems.reduce((sum,item) => sum + Number(item.quantity || 0), 0),
      products_total: normalItems.reduce((sum,item) => sum + Number(item.final_line_price || item.line_price || 0), 0)
    });
  };

  const close = () => {
    drawer.hidden = true;
    doc.body.classList.remove('simotek-cart-drawer-open');
    if (suggestions) suggestions.hidden = true;
  };

  const changeItem = async (key, quantity) => {
    const previous = currentCart?.items?.find(item => item.key === key);
    const response = await fetch(localePath('cart/change.js'), {
      method: 'POST', credentials: 'same-origin', headers: {'Content-Type':'application/json', Accept:'application/json'},
      body: JSON.stringify({id: key, quantity: Math.max(0, quantity)})
    });
    if (!response.ok) throw new Error(`CHANGE_${response.status}`);
    const nextCart = await response.json();
    render(nextCart);
    track(quantity <= 0 ? 'cart_item_removed' : 'cart_quantity_changed', {
      product_handle: previous?.handle || '',
      variant_id: String(previous?.variant_id || ''),
      previous_quantity: Number(previous?.quantity || 0),
      quantity: Math.max(0, Number(quantity || 0))
    });
  };

  const getFeeProduct = async () => {
    if (!feeProductPromise) {
      feeProductPromise = fetch(localePath(`products/${encodeURIComponent(feeHandle)}.js`), {credentials:'same-origin', headers:{Accept:'application/json'}})
        .then(response => { if (!response.ok) throw new Error('FEE_PRODUCT_MISSING'); return response.json(); });
    }
    return feeProductPromise;
  };

  const removeFeeItems = async cart => {
    for (const item of (cart.items || []).filter(isFeeItem)) {
      const response = await fetch(localePath('cart/change.js'), {
        method:'POST', credentials:'same-origin', headers:{'Content-Type':'application/json',Accept:'application/json'},
        body: JSON.stringify({id:item.key, quantity:0})
      });
      if (!response.ok) throw new Error('REMOVE_FEE_FAILED');
    }
  };

  const updateAttributes = async rate => {
    const response = await fetch(localePath('cart/update.js'), {
      method:'POST', credentials:'same-origin', headers:{'Content-Type':'application/json',Accept:'application/json'},
      body: JSON.stringify({attributes:{
        'Ville de livraison': rate?.city || '',
        'Tarif livraison': rate ? moneyDh(rate.price) : '',
        'Délai livraison': rate?.time || ''
      }})
    });
    if (!response.ok) throw new Error('ATTRIBUTES_FAILED');
  };

  const applyRate = async rate => {
    const cart = await fetchCart();
    const normalItems = (cart.items || []).filter(item => !isFeeItem(item));
    if (!normalItems.length) throw new Error('EMPTY_CART');
    const feeProduct = await getFeeProduct();
    const cents = Math.round(Number(rate.price) * 100);
    const variant = (feeProduct.variants || []).find(v => Number(v.price) === cents && v.available !== false);
    if (!variant) throw new Error(`VARIANT_MISSING_${rate.price}`);
    await removeFeeItems(cart);
    const add = await fetch(localePath('cart/add.js'), {
      method:'POST', credentials:'same-origin', headers:{'Content-Type':'application/json',Accept:'application/json'},
      body: JSON.stringify({items:[{id:variant.id, quantity:1, properties:{
        'Ville de livraison': rate.city,
        'Délai estimé': rate.time || 'À confirmer',
        '_simotek_delivery_fee':'1',
        '_simotek_delivery_rate':String(rate.price)
      }}]})
    });
    if (!add.ok) throw new Error('ADD_FEE_FAILED');
    await updateAttributes(rate);
  };

  const renderSuggestions = () => {
    if (!suggestions || !cityInput) return;
    const items = getSuggestions(cityInput.value);
    suggestions.innerHTML = items.map(rate => `<button type="button" data-cart-drawer-city-option data-city="${escapeHTML(rate.city)}"><span>${escapeHTML(rate.city)}</span><strong>${moneyDh(rate.price)}</strong></button>`).join('');
    suggestions.hidden = items.length === 0;
  };

  doc.addEventListener('click', event => {
    if (event.target.closest('[data-cart-drawer-open]')) {
      event.preventDefault();
      open();
      return;
    }
    if (event.target.closest('[data-cart-drawer-close]')) {
      event.preventDefault();
      close();
      return;
    }
    const option = event.target.closest('[data-cart-drawer-city-option]');
    if (option) {
      selectedRate = findRate(option.dataset.city);
      if (cityInput && selectedRate) cityInput.value = selectedRate.city;
      if (suggestions) suggestions.hidden = true;
      shippingStatus.textContent = selectedRate ? `${selectedRate.city} · ${moneyDh(selectedRate.price)} · ${selectedRate.time || 'Délai à confirmer'}` : '';
      checkoutButton.disabled = true;
      return;
    }
    const item = event.target.closest('[data-cart-drawer-item]');
    if (item) {
      const qtyButton = event.target.closest('[data-cart-drawer-qty]');
      const remove = event.target.closest('[data-cart-drawer-remove]');
      if (qtyButton || remove) {
        event.preventDefault();
        const current = currentCart?.items?.find(i => i.key === item.dataset.key);
        if (!current || busy) return;
        busy = true;
        const next = remove ? 0 : Number(current.quantity || 0) + Number(qtyButton.dataset.cartDrawerQty || 0);
        changeItem(item.dataset.key, next).catch(console.error).finally(() => { busy = false; });
      }
    }
  });

  cityInput?.addEventListener('input', () => {
    selectedRate = null;
    checkoutButton.disabled = true;
    checkoutButton.setAttribute('aria-disabled','true');
    renderSuggestions();
  });

  cityInput?.addEventListener('focus', renderSuggestions);
  cityInput?.addEventListener('keydown', event => {
    if (event.key === 'Escape' && suggestions) suggestions.hidden = true;
    if (event.key === 'Enter') {
      event.preventDefault();
      const rate = findRate(cityInput.value);
      if (rate) {
        selectedRate = rate;
        cityInput.value = rate.city;
        if (suggestions) suggestions.hidden = true;
      }
    }
  });

  applyButton?.addEventListener('click', async () => {
    if (busy) return;
    const rate = selectedRate || findRate(cityInput?.value);
    if (!rate) {
      shippingStatus.textContent = 'Ville introuvable. Choisissez une ville dans la liste.';
      shippingStatus.dataset.type = 'error';
      cityInput?.focus();
      return;
    }
    busy = true;
    applyButton.disabled = true;
    checkoutButton.disabled = true;
    shippingStatus.textContent = `Application du tarif ${moneyDh(rate.price)}…`;
    try {
      await applyRate(rate);
      selectedRate = rate;
      await refresh();
      track('shipping_rate_applied', {rate: Number(rate.price || 0), has_estimated_time: Boolean(rate.time)});
    } catch (error) {
      console.error('[SIMOTEK cart drawer shipping]', error);
      shippingStatus.textContent = String(error?.message || '').includes('VARIANT_MISSING_')
        ? `La variante ${moneyDh(rate.price)} manque dans le produit Frais de livraison.`
        : String(error?.message || '').includes('FEE_PRODUCT_MISSING')
          ? 'Le produit Frais de livraison SIMOTEK est introuvable.'
          : 'Impossible d’appliquer le tarif. Réessayez.';
      shippingStatus.dataset.type = 'error';
    } finally {
      busy = false;
      applyButton.disabled = false;
    }
  });

  drawer.querySelector('[data-cart-drawer-checkout-form]')?.addEventListener('submit', (event) => {
    if (checkoutButton?.disabled) {
      event.preventDefault();
      cityInput?.focus();
      return;
    }
    const normalItems = (currentCart?.items || []).filter(item => !isFeeItem(item));
    const feeItem = (currentCart?.items || []).find(isFeeItem);
    track('checkout_started', {
      item_count: normalItems.reduce((sum,item) => sum + Number(item.quantity || 0), 0),
      products_total: normalItems.reduce((sum,item) => sum + Number(item.final_line_price || item.line_price || 0), 0),
      shipping_total: Number(feeItem?.final_line_price || feeItem?.line_price || 0),
      total: Number(currentCart?.total_price || 0)
    });
  });

  doc.addEventListener('keydown', event => { if (event.key === 'Escape' && !drawer.hidden) close(); });

  window.SimotekCartDrawer = {open, close, refresh};
})();
